export default "<div class=\"scroll-to-top\" [ngClass]=\"{'show-scrollTop': onWindowScrolled}\">\r\n</div>\r\n";